import Vue from 'vue';
import VueRouter, { Route } from 'vue-router';
import { Dictionary } from 'vue-router/types/router';
import { KSelectFi, KSelectSite } from '@kasasa/fbase-components';
import RouterView from '@/components/RouterView.vue';
import PageProfileFormPage from '@/pages/PageProfileFormPage.vue';
import ListPageProfilesPage from '@/pages/ListPageProfilesPage.vue';



Vue.use(VueRouter);

const mergeMeta = (route: Route): Dictionary<string> => {
	return { ...route.params, ...route.meta };
};

export const RouteName = {
	HOME: 'Home',
	CLIENT_HOME: 'ClientHome',
	PAGE_PROFILE_LIST: 'PageProfileList',
	PAGE_PROFILE_ADD: 'PageProfileAdd',
	PAGE_PROFILE_EDIT: 'PageProfileEdit',
	PAGE_PROFILE_VIEW: 'PageProfileView'
};

const routes = [
	{
		path: '/',
		name: RouteName.HOME,
		component: KSelectFi
	},
	{
		path: '/:clientId([1-9]\\d*)',
		component: RouterView,
		children: [
			{
				path: '',
				name: RouteName.CLIENT_HOME,
				component: KSelectSite,
				props: mergeMeta,
				meta: {
					showSiteSelect: true
				},
			},
			{
				path: 'site/:siteId([1-9]\\d*)',
				redirect: { name: RouteName.PAGE_PROFILE_LIST },
				component: RouterView,
				children: [
					{
						path: 'profile-page',
						name: RouteName.PAGE_PROFILE_LIST,
						component: ListPageProfilesPage,
						props: mergeMeta,
						meta: {
							showSiteSelect: true,
							showAdd: true,
						},
					},
					{
						path: 'add',
						name: RouteName.PAGE_PROFILE_ADD,
						component: PageProfileFormPage,
						props: mergeMeta,
						meta: {
							showSiteSelect: true,
							mode: 'add'
						},
					},					
					{
						path: 'profile-page/:pageProfileId([1-9]\\d*)/edit',
						name: RouteName.PAGE_PROFILE_EDIT,
						component: PageProfileFormPage,
						props: mergeMeta,
						meta: {
							showSiteSelect: true,
							mode: 'edit'
						},
					}
				],
			},
		],
	},
	{
		path: '*',
		redirect: { name: RouteName.HOME }
	}
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
});

export default router;
